import FqApi from '@/services/fq-api'

const baseUrl = '/quotes/attachments/categories'

export default {
  async getCategories() {
    const url = `${baseUrl}/list`
    return (await FqApi.get(url)).data
  },
  /**
   * Resolves a system category id from a list returned by getCategories().
   * Matching is on the stable systemKey, never on the display name: the names have drifted before
   * and every caller that matched on them silently stopped filing documents.
   * Returns null when the category is missing so the caller can report it instead of uploading
   * into the void.
   */
  getCategoryIdBySystemKey(categories, systemKey) {
    const category = (categories || []).find((row) => row?.systemKey === systemKey)
    return category?.quoteAttachmentCategoryId ?? null
  }
}
